import { Snackbar, SnackbarContent } from "@mui/material";
import BookmarkIcon from '@mui/icons-material/Bookmark';
import React, { FC, ReactElement, ReactNode, useContext, useEffect, useState } from 'react';
import { useMsal } from "@azure/msal-react";
import Toolbar from '@mui/material/Toolbar';
import Box from '@mui/material/Box';
import { ReactComponent as LeftPanelOpen } from "../icons/left_panel_open.svg";
import { ReactComponent as LeftPanelClose } from "../icons/left_panel_close.svg";
import IconButton from '@mui/material/IconButton';
import SettingsIcon from '@mui/icons-material/Settings';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import { IPublicClientApplication } from '@azure/msal-browser';
import Divider from '@mui/material/Divider';
import MenuList from '@mui/material/MenuList';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Check from '@mui/icons-material/Check';
import Menu from '@mui/material/Menu';
import { Paper, Popover, styled } from '@mui/material';
import { useTranslation } from 'react-i18next';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import { isDefaultDomain, isEfesoDomain, isRtDomain, isGcDomain } from '../config';
import { Context } from '../components/context';
import { AppContext } from '../models/applicationState';
import { UserRole } from '../models/user';
import ConfirmationPanel from '../components/confirmationPanel';

interface HeaderProps {
    open: boolean,
    toggleDrawer: () => void,
    openProjectPanel: boolean,
    showProjectPanel?: boolean,
    toggleProjectPanel: () => void
}

function signOutClickHandler(instance: IPublicClientApplication) {
    const logoutRequest = {
        account: instance.getActiveAccount(),
    };
    instance.logoutRedirect(logoutRequest);
}

function DenseMenu() {
    const { instance } = useMsal();
    const { t, i18n } = useTranslation();
    const [lng, setLng] = useState(i18n.language || window.localStorage.i18nextLng);

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const [anchorSecurityEl, setAnchorSecurityEl] = React.useState<null | HTMLElement>(null);
    const openSecurity = Boolean(anchorSecurityEl);
    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleSecurityClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorSecurityEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const handleSecurityClose = () => {
        setAnchorSecurityEl(null);
    };
    const changeLanguage = (selection: string) => {
        // console.log("current language: " + lng);
        // console.log("current i18n: " + i18n.language);
        // console.log("current local storage value: " + window.localStorage.i18nextLng);
        i18n.changeLanguage(selection);
        setLng(selection);
    }

    const style = {
        width: 700,
        bgcolor: '#fff',
        p: 4,
    };

    return (
        // <Paper sx={{ width: 160 }}>
        // </Paper>
        <div>
            <MenuList dense>
                <MenuItem
                    selected={lng === 'en'}
                    onClick={() => changeLanguage('en')}>
                    {lng === 'en' ?
                        <>
                            <ListItemIcon>
                                <Check />
                            </ListItemIcon>
                            {t('label.lang_en')}
                        </>
                        :
                        <ListItemText inset>
                            {t('label.lang_en')}
                        </ListItemText>
                    }
                </MenuItem>
                <MenuItem
                    selected={lng === 'de'}
                    onClick={() => changeLanguage('de')}>
                    {lng === 'de' ?
                        <>
                            <ListItemIcon>
                                <Check />
                            </ListItemIcon>
                            {t('label.lang_de')}
                        </>
                        :
                        <ListItemText inset>
                            {t('label.lang_de')}
                        </ListItemText>
                    }
                </MenuItem>
                <Divider />
                <MenuItem onClick={handleSecurityClick}>
                    <ListItemText>{t('toolbar.security')}</ListItemText>
                </MenuItem>
                <Divider />
                <MenuItem onClick={handleClick}>
                    <ListItemText>{t('button.about')}</ListItemText>
                </MenuItem>
                <Divider />
                <MenuItem onClick={() => signOutClickHandler(instance)}>
                    <ListItemText>{t('button.logout')}</ListItemText>
                </MenuItem>
            </MenuList>
            <Popover
                open={openSecurity}
                onClose={handleSecurityClose}
                anchorEl={anchorSecurityEl}
                role={undefined}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left"
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "left"
                }}
            >
                <Paper>
                    <Box sx={style}>
                        <iframe id="security-iframe" src={t('security.template')}
                            width={"100%"}
                            height={"500px"}
                            frameBorder="0"
                        />
                    </Box>
                </Paper>
            </Popover>
            <Popover
                open={open}
                onClose={handleClose}
                anchorEl={anchorEl}
                role={undefined}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left"
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "left"
                }}
            >
                <Paper>
                    <Box sx={style}>
                        <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                            {t('about.title')}
                            <br />
                            <br />
                            <a href="https://www.leadwithpinnacle.com/">leadwithpinnacle.com</a>
                            <br />
                            {t('about.copyright')}
                        </Typography>
                    </Box>
                </Paper>
            </Popover>
        </div>
    );
}

function PositionedMenu() {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const { t } = useTranslation();
    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <div>
            <IconButton
                color="inherit"
                aria-label={t('label.settings')}
                onClick={handleClick}
                id="demo-positioned-button"
                aria-controls={open ? 'demo-positioned-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
            // edge="end"
            // sx={{
            //     // marginRight: 0,
            //     // ...(open && { display: 'none' }),
            // }}
            >
                <SettingsIcon />
            </IconButton>
            <Menu
                id="demo-positioned-menu"
                aria-labelledby="demo-positioned-button"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
            // anchorOrigin={{
            //     vertical: 'bottom',
            //     horizontal: 'left',
            // }}
            // transformOrigin={{
            //     vertical: 'top',
            //     horizontal: 'left',
            // }}
            >
                <DenseMenu />
            </Menu>
        </div>
    );
}

const hostName = window.location.hostname;

const MainHeader: FC<HeaderProps> = (props: HeaderProps): ReactElement => {
    const { instance } = useMsal();
    const { t } = useTranslation();
    const appContext = useContext<AppContext>(Context);
    const userFullName = (appContext.state.invoker?.lastName && appContext.state.invoker?.firstName) ? (appContext.state.invoker?.firstName + ' ' + appContext.state.invoker?.lastName) : instance.getActiveAccount()?.name;

    const [showBookmarkDialog, setShowBookmarkDialog] = useState(false);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState<ReactNode>("");


    // TODO: This is a temporary solution to change the background color of the toolbar based on the domain and the user role
    // TODO: This should be done in the theme file if possible
    const toolbarStyle = {
        pr: '24px', // keep right padding when drawer closed    
    };
    if (isDefaultDomain()) {
        toolbarStyle['backgroundColor'] = appContext.state.invoker?.role === UserRole.Actor ? '#777586' : '#242C63';
    }
    if (isGcDomain()) {
        toolbarStyle['backgroundColor'] = appContext.state.invoker?.role === UserRole.Actor ? '#777586' : '#2d6bff';
    }

    const handleBookmark = () => {
        const url = window.location.href;
        const title = document.title;

        try {
            navigator.clipboard.writeText(url).then(() => {
                const anyWindow = window as any;
                let bookmarkAdded = false;

                if (anyWindow.sidebar?.addPanel) {
                    // Firefox <=22
                    anyWindow.sidebar.addPanel(title, url, '');
                    bookmarkAdded = true;
                } else if (anyWindow.external?.AddFavorite) {
                    // Internet Explorer
                    anyWindow.external.AddFavorite(url, title);
                    bookmarkAdded = true;
                }

                if (bookmarkAdded) {
                    setSnackbarMessage(t('bookmark.success'));
                } else {
                    // Show unsupported message and manual instructions on two lines
                    setSnackbarMessage(<>{t('bookmark.unsupported')}<br />{t('bookmark.manual')}</>);
                }
                setSnackbarOpen(true);
            }).catch(() => {
                // If clipboard fails, fallback message
                setSnackbarMessage(t('bookmark.error'));
                setSnackbarOpen(true);
            });
        } catch (error) {
            setSnackbarMessage(t('bookmark.error'));
            setSnackbarOpen(true);
        }
    };



    const handleSnackbarClose = () => {
        setSnackbarOpen(false);
    };

    return (
        <>
            <Toolbar sx={toolbarStyle}>
                <IconButton
                    edge="start"
                    color="inherit"
                    aria-label={t('label.menu_drawer')}
                    onClick={props.toggleDrawer}
                    sx={{
                        marginRight: '36px',
                    }}
                >
                    {props.open ? <LeftPanelClose /> : <LeftPanelOpen />}
                </IconButton>
                {isDefaultDomain() &&
                    <Box
                        component="img"
                        sx={{
                            height: 28,
                            marginRight: 1,
                        }}
                        alt="Pinnacle logo"
                        src="/icon_gray.svg"
                    />
                }

                <Box
                    component="img"
                    sx={!isDefaultDomain() ? {
                        height: 38,
                    } : {
                        height: 18,
                    }}
                    alt="Pinnacle"
                    src={
                        isEfesoDomain() ? '/efeso.png' :
                        (isRtDomain() ? '/rt.png' :
                        (isGcDomain() ? '/logo_white.svg' : '/logo_white.svg'))
                    }
                />

                <Box sx={{ flexGrow: 1 }} />

                <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                    <Avatar sx={{ width: 24, height: 24 }} />
                    <Tooltip title={instance.getActiveAccount()?.username}>
                        <Typography variant="subtitle2" sx={{ marginRight: 1 }}>
                            {userFullName}
                        </Typography>
                    </Tooltip>
                </Box>

                <Tooltip title={t('bookmark.tooltip')}>
                    <IconButton
                        edge="end"
                        color="inherit"
                        aria-label={t('bookmark.tooltip')}
                        onClick={() => setShowBookmarkDialog(true)}
                    >
                        <BookmarkIcon />
                    </IconButton>
                </Tooltip>

                <PositionedMenu />
                {props.showProjectPanel &&
                    <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                        <Typography variant="subtitle2" sx={{ marginLeft: 1, marginRight: 1 }}>
                            {t('toolbar.projects')}
                        </Typography>
                        <IconButton
                            edge="start"
                            color="inherit"
                            aria-label={t('label.project_drawer')}
                            onClick={props.toggleProjectPanel}
                        >
                            {props.openProjectPanel ? <KeyboardDoubleArrowRightIcon /> : <KeyboardDoubleArrowLeftIcon />}
                        </IconButton>
                    </Box>
                }
            </Toolbar>

            {/* Confirmation Dialog */}
            <ConfirmationPanel
                showModal={showBookmarkDialog}
                hideModal={() => setShowBookmarkDialog(false)}
                confirmModal={() => {
                    setShowBookmarkDialog(false);
                    handleBookmark();
                }}
                title={t('bookmark.label')}
                content={t('bookmark.confirmation')}
                action="bookmark"
            />

            {/* Snackbar for Notifications */}
            <Snackbar
                open={snackbarOpen}
                onClose={handleSnackbarClose}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
                autoHideDuration={5000}
            >
                <SnackbarContent
                    sx={{ borderRadius: 2 }}
                    message={snackbarMessage}
                />
            </Snackbar>

        </>
    );
};

export default MainHeader;